/* eslint-disable max-len */
/* eslint-disable no-unneeded-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Dropzone from 'react-dropzone';
import Autocomplete from 'react-autocomplete';
import _ from 'lodash';
import PulpoField from '../../../pulpo_visualizer/fields';
import PictureDraggable from '../../sms/components/PictureDraggable';
import { GLOBAL_LOCATION, CUSTOM_LOCATION } from '../../../constants/ModelStatus';
import fieldstyles from '../../../pulpo_visualizer/fields/fields.module.scss';
import Clickable from '../../../components/clickable/Clickable';
import FormattedMessageWithClass from '../../../components/formattedMessageWithClass';
import styles from './fixedFields.module.scss';
import LocationFields from '../../sms/components/LocationFields';
import { allValidFileExtensions, checkMultiFilesValidation } from '../../../utils/helpers';

class FixedFields extends Component {
  state = { currentValue: undefined }

  static getDerivedStateFromProps(props, state) {
    if (props.info.logged_by?.id && state.currentValue === undefined) {
      return { ...state, currentValue: props.info.logged_by.fullname };
    }
    return state;
  }

  handleAutocompleteChange = (e) => {
    const { searchForUser } = this.props;
    this.setState({ currentValue: e.target.value });
    searchForUser(e.target.value);
  }

  handleAutocompleteSelect = (val, item) => {
    const { handleAnswerChanged, handleFieldErrorChanged } = this.props;

    this.setState({ currentValue: val });
    handleAnswerChanged('info', item, 'logged_by');
    handleFieldErrorChanged('logged_by', false);
  }

  handleDrop = (dropped) => {
    if (!checkMultiFilesValidation(dropped, allValidFileExtensions)) return;
    const { handleAnswerChanged, info } = this.props;
    handleAnswerChanged('info', [...info.attachments, ...dropped], 'attachments');
  }

  handleRemoveImage = (r) => {
    const { handleAnswerChanged, info } = this.props;
    const res = info.attachments.filter(e => e !== r);
    handleAnswerChanged('info', res, 'attachments');
  }

  handleCustomLocationAttachment = (section, answer, fieldId) => {
    const { handleAnswerChanged, location_attachments } = this.props;
    handleAnswerChanged(section, answer, fieldId);
    let LocationImage = '';
    if (answer && location_attachments) {
      const LocationAttachment = location_attachments.filter(
        s => s.activity_type.name === answer
      );
      if (LocationAttachment.length > 0) {
        LocationImage = LocationAttachment[0].attachment;
        handleAnswerChanged(section, LocationImage, 'locationImage');
        this.setState({ TerminalModal: true });
      }
    }
  }

  handleDisplay = () => {
    const { TerminalModal } = this.state;
    this.setState({ TerminalModal: !TerminalModal });
  }

  getFieldTitle = (key, fallback) => this.handleFieldTitles(key) || fallback;

  handleFieldTitles = (field) => {
    const { leaseMaintenance_schema } = this.props;
    let title = leaseMaintenance_schema?.workorder?.schema?.default_fields?.[field]?.title;
    return title;
  }

  render() {
    const { currentValue, TerminalModal } = this.state;
    const {
      handleAnswerChanged,
      showFormErrors,
      handleFieldErrorChanged,
      userlist,
      info,
      public_form,
      leaseMaintenance_schema,
      categories,
      locationChanged,
      changeLocationChangedStatus,
      global_locations,
      locations,
      sub_locations,
      map_view,
      enable_locations_in_public,
      defaultLocation,
      map,
      nawoIcon,
      eachfield
    } = this.props;
    const filteredCategories = public_form && leaseMaintenance_schema?.public_attributes?.nawo_categories_in_public?.length
    ? leaseMaintenance_schema?.public_attributes?.nawo_categories_in_public : leaseMaintenance_schema?.settings?.selected_categories;
    const selectedCategories = (!leaseMaintenance_schema?.settings?.selected_categories?.length && !public_form)
    || (public_form && !leaseMaintenance_schema?.public_attributes?.nawo_categories_in_public?.length)
        ? Object.keys(categories).map(e => ({
            key: `${categories[e].id}`,
            value: categories[e].name
          }))
        : filteredCategories?.map(
            category => ({ key: category?.value, value: category?.label })
          );
    const defaultCheck = leaseMaintenance_schema?.workorder?.schema?.default_fields;
    const subCategories = info?.category_id ? categories.filter(e => Number(e.id) === Number(info.category_id))[0]?.sub_categories : [];
    const hideComponent = key => !(public_form ? defaultCheck?.[key]?.disable_for_public : false) ?? true;
    return (
      <>
        {!public_form && eachfield==='default_logged_by' && (
          <div className={fieldstyles.field}>
            <>
              <FormattedMessageWithClass
                className={fieldstyles.title}
                id={this.getFieldTitle('default_logged_by', 'default_requested_by')}
                defaultMessage={this.getFieldTitle('default_logged_by', 'Requested by')}
              />
              <Autocomplete getItemValue={item => item.fullname} items={userlist}
                wrapperStyle={{ position: 'relative' }}
                value={currentValue}
                onChange={this.handleAutocompleteChange}
                onSelect={this.handleAutocompleteSelect}
                renderMenu={children => (
                  <div className={styles.autocompleteMenu}>
                    {children}
                  </div>
                )}
                renderItem={(item, isHighlighted) => (
                  <div key={item.id} className={`${styles.menuItem} ${isHighlighted && styles.highlighted}`}>
                    {item.fullname}
                  </div>
                )}
              />
              {!currentValue && showFormErrors && (
              <small>
                <FormattedMessage id="pulpoforms.errors.not_blank" defaultMessage="There is an error in this field" />
              </small>
              )}
            </>
          </div>
        )}
        {hideComponent('default_reported_date') && eachfield === 'default_reported_date' && (
          <PulpoField key="date" id="report_date" type="datetime"
            translationID={this.getFieldTitle('default_reported_date', 'workorder.create.date')}
            title={this.getFieldTitle('default_reported_date', 'Report date')}
            isRequired handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
            answer={info.report_date}
            showFieldErrors={showFormErrors}
            handleFieldErrorChanged={handleFieldErrorChanged}
            customStyles={{ flex: '0 1 100%' }}

          />
        )}
        {hideComponent('default_category') && eachfield === 'default_category' && (
          <>
            <PulpoField key="category_id" id="category_id" type="select"
              translationID={this.getFieldTitle('default_category', 'workorder.create.category')}
              title={this.getFieldTitle('default_category', 'Category')}
              isRequired={public_form && defaultCheck?.default_category.disable_for_public ? false : true}
              className={styles.public_category}
              handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
              answer={info.category_id}
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
              values={selectedCategories}
              disabled={(public_form && defaultCheck?.default_category.disable_for_public) || false}
              customStyles={{ flex: '0 1 100%' }}
            />
            {subCategories && Object.keys(subCategories).length !== 0 && (
              <PulpoField
                key="subcategory" id="subcategory" type="select" title="Sub Category" isRequired
                translationID="workorder.create.subcategory" className={styles.public_category}
                handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
                answer={info.subcategory}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged}
                values={subCategories.map(item => ({
                  key: item,
                  value: item
                }))}
                customStyles={{ flex: '0 1 100%' }}
              />
            )}
          </>
        )}
        {hideComponent('default_priority') && eachfield === 'default_priority' && (
          <PulpoField key="priority" id="priority" type="select"
            title={this.getFieldTitle('default_priority', 'Priority')}
            isRequired={public_form && defaultCheck?.default_priority.disable_for_public ? false : true}
            translationID={this.getFieldTitle('default_priority', 'workorder.create.priority')}
            className={styles.leasePriority}
            handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
            answer={info.priority}
            showFieldErrors={showFormErrors}
            handleFieldErrorChanged={handleFieldErrorChanged}
            values={leaseMaintenance_schema?.priority ? leaseMaintenance_schema?.priority.map(e => (
              ({ key: e.key.toString(), value: e.value }))) : []}
            disabled={(public_form && defaultCheck?.default_priority.disable_for_public) || false}
            customStyles={{ flex: '0 1 100%' }}

          />
        )}
        {categories && categories?.filter(item => item.id === Number(info?.category_id) && item?.name?.toLowerCase()?.includes('other'))?.length > 0
        && leaseMaintenance_schema?.other_description && (
          <div className={styles.fullInput}>
            <PulpoField key="other_category" id="other_category_description" type="string" title="OtherCategory Input" isRequired
              translationID="workorder.create.other" className={styles.category}
              handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
              answer={info?.other_category_description}
              showFieldErrors={showFormErrors}
              handleFieldErrorChanged={handleFieldErrorChanged}
              customStyles={{ flex: '0 1 100%' }}
            />
          </div>
        )}
        {leaseMaintenance_schema?.public_attributes?.enable_company_name && eachfield === 'default_company_name' && hideComponent('default_company_name') && (
        <div className={styles.fullInput}>
          <PulpoField key="tenant_id" id="tenant_id" type="select"
            title={this.getFieldTitle('default_company_name', 'Company Name')}
            translationID={this.getFieldTitle('default_company_name', 'tenants.new.name')}
            className={styles.category}
            handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
            answer={info.tenant_id}
            showFieldErrors={showFormErrors}
            handleFieldErrorChanged={handleFieldErrorChanged}
            values={leaseMaintenance_schema?.tenants ? _.orderBy(leaseMaintenance_schema?.tenants, [tenant => tenant.name.toLowerCase()], ['asc']).map(e => (
              ({ key: e.id.toString(), value: e.name })
            )): []}
            customStyles={{ flex: '0 1 100%' }}

          />
        </div>
        )}
        {eachfield === 'default_description' && (
          <PulpoField key="desc" id="problem_description" type="string"
            translationID={this.getFieldTitle('default_description', 'workorder.create.description')}
            className={styles.fullInput}
            widget={{ type: 'textarea' }}
            title={this.getFieldTitle('default_description', 'Problem description')}
            isRequired
            handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
            answer={info.problem_description}
            showFieldErrors={showFormErrors} handleFieldErrorChanged={handleFieldErrorChanged}
            customStyles={{ flex: '0 1 100%' }}

          />
        )}
        {hideComponent('default_photos') && eachfield === 'default_photos' && (
          <div className={styles.fullInput}>
            <FormattedMessageWithClass
              className={styles.label}
              id={this.getFieldTitle('default_photos', 'workorder.create.attachments')}
              defaultMessage={this.getFieldTitle('default_photos', 'Attachments')}
            />
            <Dropzone onDrop={this.handleDrop} disableClick
              className={`${styles.dropzone} ${styles.dropzone1}`}
            >
              {({ open }) => (
                <>
                  <p className={styles.browsetext}>
                    <FormattedMessage id="airport.logo.text1" defaultMessage="Drag an image here or" />
                    <button type="button" onClick={() => open()}>
                      <FormattedMessage id="airport.logo.button" defaultMessage="browse" />
                    </button>
                    <FormattedMessage id="airport.logo.text2" defaultMessage="for an image to upload." />
                  </p>
                </>
              )}
            </Dropzone>
            {info.attachments.length > 0 && (
            <div className={styles.photos}>
              {info.attachments.map(e => (
                <div key={e.name} className={styles.wrapper}>
                  <Clickable onClick={() => this.handleRemoveImage(e)}>&times;</Clickable>
                  <img src={e.preview} alt={e.name} />
                </div>
              ))}
            </div>
            )}
          </div>
        )}
        {enable_locations_in_public && <>
          {global_locations?.length > 0 && eachfield === 'default_location'
            && hideComponent('default_location')
            && leaseMaintenance_schema?.workorder?.location === GLOBAL_LOCATION
            && <>
              <LocationFields
                info={info}
                locationList={global_locations}
                onInfoChange={(a, b) => handleAnswerChanged('info', b, a)}
                withoutDepartments
                locationKey="name"
                withFloorPlan
                isRequiredTrue={defaultCheck?.default_location?.required}
                showFormErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged}
                defaultLocation={defaultLocation}
                map={map}
                containerClassName={styles.myCustomLocations}
                locimg={{ width: '100%' }}
                customStyles={{ flex: '0 1 100%' }}

              />
               </>}
          {leaseMaintenance_schema.workorder
            && leaseMaintenance_schema.workorder.location === CUSTOM_LOCATION
            && eachfield === 'default_location' &&hideComponent('default_location') &&(
            <>
              <PulpoField key="location" id="location" type="select"
                title={this.getFieldTitle('default_location', 'Location')}
                translationID={this.getFieldTitle('default_location', 'workorder.create.location')}
                className={styles.fullInput}
                handleValueChange={(a, b) => this.handleCustomLocationAttachment('info', a, b)}
                answer={info.location}
                showFieldErrors={showFormErrors}
                handleFieldErrorChanged={handleFieldErrorChanged}
                isRequired={defaultCheck?.default_location?.required}
                values={
                    locations?.length>0 ? locations.map(e => (
                      { key: e.name, value: e.name }
                    ))
                      :[]}
                customStyles={{ flex: '0 1 100%' }}

              />
                {info?.location && ['Other', 'other']?.includes(info?.location) && leaseMaintenance_schema?.settings?.other_location_description && (
                  <PulpoField key="other_location" id="other_location_description" type="string" title="OtherLocation Input"
                    translationID="workorder.create.otherLocation" className={styles.category}
                    handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
                    answer={info?.other_location_description}
                    handleFieldErrorChanged={handleFieldErrorChanged}
                    customStyles={{ flex: '0 1 100%' }}

                  />
                )}
                {info?.location && sub_locations?.filter(s => s?.activity_type?.name === info?.location)?.length > 0 && (
                <PulpoField key="sub_location" id="sub_location" type="select"
                  widget={{ type: 'singleSearch' }}
                  title="Sub Location"
                  translationID="lease.maintenance.settings.sub_location"
                  className={styles.category}
                  handleValueChange={(a, b) => {
                    handleAnswerChanged('info', a, b);
                  }}
                  answer={info.sub_location}
                  handleFieldErrorChanged={handleFieldErrorChanged}
                  values={_.sortBy(sub_locations?.length>0 && sub_locations.filter(
                    s => s.activity_type.name === info.location
                  ), [loc => loc.name.toLowerCase()]).map(e => ({ key: e.name, value: e.name, text: e.name }))}
                  StylesClasses={styles.subLocationDrop}
                  customStyles={{ flex: '0 1 100%' }}
                />

                )}
                {info?.location && info?.airfield_location
                && (map_view === 'indoor_and_airfield' || map_view === 'airfield_map')
                && (
                <PulpoField
                  key="airfield_location"
                  id="airfield_location"
                  type="location"
                  translationID="lease.maintenance.location.indoor_map"
                  title="Airfield Location"
                  noPolygon
                  handleValueChange={(a, b) => handleAnswerChanged('info', a, b)}
                  answer={info?.airfield_location}
                  showFieldErrors={() => {}}
                  handleFieldErrorChanged={() => {}}
                  disabled
                  locationChanged={locationChanged}
                  changeLocationChangedStatus={changeLocationChangedStatus}
                  className={styles.fullInput}
                  map_style={map?.map_style}
                  mapbox_style={map?.mapbox_style}
                  customStyles={{ flex: '0 1 100%' }}

                />
                )}
                {info.location && info.locationImage && info.locationImage.length > 0
                && (map_view === undefined || map_view === 'indoor_and_airfield' || map_view === 'indoor_map')
                && (
                <div className={styles.fullInput}>
                  <PictureDraggable attachment={info.locationImage[0]} position={info.location_marked}
                    handleAnswerChanged={handleAnswerChanged} handleDisplay={this.handleDisplay}
                    location={info.location} display={TerminalModal}
                    nawoIcon={nawoIcon}
                    nawo
                  />
                </div>
                )}
                {info.location && info.locationImage
                && info.locationImage.length > 0 && (map_view === undefined || map_view === 'indoor_and_airfield' || map_view === 'indoor_map') && (
                <div>
                  <Clickable onClick={this.handleDisplay} className={styles.terminalLink}>
                    <FormattedMessage id="maintenance.custom_location.click_notation" defaultMessage="Please click on the map below" />
                  </Clickable>
                </div>
                )}
            </>
          )}
                                       </>}
      </>
    );
  }
}

FixedFields.propTypes = {
  info: PropTypes.shape({}).isRequired,
  handleAnswerChanged: PropTypes.func.isRequired,
  handleFieldErrorChanged: PropTypes.func.isRequired,
  showFormErrors: PropTypes.bool,
  userlist: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  searchForUser: PropTypes.func.isRequired,
  categories: PropTypes.shape({}).isRequired
};

FixedFields.defaultProps = {
  showFormErrors: false
};

export default FixedFields;
